export const SOCIAL_URLS = {
  youtube: "https://www.youtube.com/@Kitosm",
  tiktok: "https://www.tiktok.com/@kitosenredes",
  instagram: "https://www.instagram.com/kitosenredes",
  facebook: "https://www.facebook.com/kitosenredes",
  twitch: "https://www.twitch.tv/kitosenredes",
  telegram: "https://t.me/ofertasdekitos",
  threads: "https://www.threads.com/@kitosenredes",
  discord: "https://discord.gg/XhMkgg6Ev8",
};
